/**
 * Time window (ms) for batching multiple requests into one.
 * 10ms balances latency vs batching efficiency - most React renders
 * complete within this window, allowing related queries to batch together.
 */
export const BATCH_WINDOW_MS = 10;

/**
 * Shared resolver for batchers that return keyed object responses.
 * Used when the backend returns { "id1": {...}, "id2": {...} }
 * and we need to match a query's key to the response object.
 */
export const keyedObjectResolver = <TItem, TQuery extends Record<string, any>>(key: keyof TQuery) => (
  items: Record<string, TItem>,
  query: TQuery,
): TItem | null => {
  const id = String(query[key]);
  return items[id] ?? null;
};
